import React, { useState, useRef, useEffect } from 'react'
import './DkabioJoggingSuccessCard.css'

const LINE_URL = 'https://lin.ee/rGWQUQC'

// 在 App 內嵌 WebView 裡 navigator.clipboard 常不可用，退回 execCommand
const copyText = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch (e) {
    // 繼續走 fallback
  }
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.setAttribute('readonly', '')
  textArea.style.position = 'fixed'
  textArea.style.opacity = '0'
  document.body.appendChild(textArea)
  textArea.select()
  try {
    return document.execCommand('copy')
  } catch (e) {
    return false
  } finally {
    document.body.removeChild(textArea)
  }
}

const DkabioJoggingSuccessCard = () => {
  const [toast, setToast] = useState('')
  const timerRef = useRef(null)

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const handleCopy = async () => {
    const ok = await copyText(LINE_URL)
    setToast(
      ok ? '✓ 連結已成功複製至剪貼簿！' : `複製失敗，請手動複製：${LINE_URL}`
    )
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setToast(''), 2500)
  }

  return (
    <main className="dkabio-jog">
      <div className="dkabio-jog__check">
        <svg
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
      </div>
      <h1 className="dkabio-jog__title">
        感謝您的填答，
        <br />
        歡迎轉發分享！
      </h1>

      <p className="dkabio-jog__desc">
        更多即時資訊與健康內容，
        <br />
        歡迎加入 <strong>DKABio 官方 LINE</strong>
      </p>

      <div className="dkabio-jog__tags">
        <span>💚 衛教新知</span>
        <span>💡 APP操作指南</span>
        <span>🎁 最新產品資訊</span>
      </div>

      <a
        className="dkabio-jog__line-btn"
        href={LINE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="dkabio-jog__line-left">
          <svg className="dkabio-jog__line-icon" viewBox="0 0 24 24">
            <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
          </svg>
          <span>
            <span className="dkabio-jog__line-sub">DKABio LINE 官方帳號</span>
            <span className="dkabio-jog__line-main">點擊加入</span>
          </span>
        </span>
        <svg
          className="dkabio-jog__arrow"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </a>

      <div className="dkabio-jog__copy-row">
        <button
          type="button"
          className="dkabio-jog__copy-btn"
          onClick={handleCopy}
        >
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
            />
          </svg>
          複製加入連結
        </button>
      </div>
      <div className="dkabio-jog__toast" aria-live="polite">
        {toast}
      </div>

      <div className="dkabio-jog__footer">
        <div className="dkabio-jog__emoji">🏃‍♂️✨</div>
        <p className="dkabio-jog__slogan">
          AI智慧超慢跑墊，
          <br />
          期待與您一起踏上健康旅程！
        </p>
        <p className="dkabio-jog__company">DKABio 浚鴻數據開發股份有限公司</p>
      </div>
    </main>
  )
}

export default DkabioJoggingSuccessCard
